import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { deepExtract } from 'helpers/deep';
import { selectUserDetectedLocation } from 'redux/modules/locale';
import { glsLocation, searchLocationAutocomplete, searchLocationDetails } from 'redux/saga/entities/bound';
import { setInputLocation, setPlaceQuery } from './LocationInput.reducer';

export const LOAD_DETECTED_LOCATION = 'LOCATION_INPUT/LOAD_DETECTED_LOCATION';
export const LOAD_PLACE = 'LOCATION_INPUT/LOAD_PLACE';
export const QUERY_PLACES = 'LOCATION_INPUT/QUERY_PLACES';

export const loadDetectedLocation = () => ({ type: LOAD_DETECTED_LOCATION });
export const loadPlace = placeId => ({ type: LOAD_PLACE, placeId });
export const queryPlaces = query => ({ type: QUERY_PLACES, query });

export function* getLatLonName(client, lat, lon) {
  const { msa, areas } = yield call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]);
  return deepExtract('city', msa) || deepExtract('city', areas) || deepExtract('most_specific_area', areas);
}

export function* doQueryPlaces(client, { query }) {
  try {
    if (query) {
      const detectedLocation = yield select(selectUserDetectedLocation);
      yield call(
        fetchEntityIfNeeded,
        searchLocationAutocomplete,
        [
          client,
          {
            query,
            near: detectedLocation,
            type: 'cities',
          },
        ],
        {
          key: `locationInput_${query}`,
        }
      );
    }
    yield put(setPlaceQuery(query));
  } catch (error) {
    yield call(logger.warn, 'LocationInput: Failed while querying location', error);
  }
}

export function* doLoadPlace(client, { placeId }) {
  if (!placeId) {
    return;
  }

  try {
    const { lat, lon, name } = yield call(fetchEntityIfNeeded, searchLocationDetails, [client, placeId]);
    yield put(setInputLocation({ lat, lon, name }));
  } catch (error) {
    yield call(logger.warn, 'LocationInput: Failed while retrieving place data', error);
  }
}

export function* doLoadDetectedLocation(client) {
  const detectedLocation = yield select(selectUserDetectedLocation);

  if (!detectedLocation || (detectedLocation.lat === 0 && detectedLocation.lon === 0)) {
    yield call(
      logger.warn,
      'LocationInput: Failed while retrieving current location data, no location',
      detectedLocation
    );
    return;
  }

  try {
    const { lat, lon } = detectedLocation;
    const name = yield call(getLatLonName, client, lat, lon);
    yield put(setInputLocation({ lat, lon, name }));
  } catch (error) {
    yield call(logger.warn, 'LocationInput: Failed while retrieving current location data', error);
  }
}

export function* watchLocationInputSagas(client) {
  yield takeEvery(QUERY_PLACES, doQueryPlaces, client);
  yield takeEvery(LOAD_PLACE, doLoadPlace, client);
  yield takeEvery(LOAD_DETECTED_LOCATION, doLoadDetectedLocation, client);
}
